import { useAlert, useToast } from "@apex/component-library";
import axios, { AxiosError } from "axios";
import { DateTime } from "luxon";
import { useQuery } from "react-query";

import { getAppConfigSetting } from "../utils/getAppConfigSetting";
import { GET_MARGIN_CALLS } from "./constants";
import queryKeys from "./queryKeys";

export function useGetMarginExportCsv(searchParamString?: string) {
  const toast = useToast();
  const { setAlert } = useAlert();

  const marginCallsApiURL = `${getAppConfigSetting(
    "apiUrl"
  )}${GET_MARGIN_CALLS}`;

  const fetchMarginCalls = async () => {
    const { data } = await axios.get(
      `${marginCallsApiURL}?${searchParamString}&type=csv`,
      {
        withCredentials: true,
      }
    );

    triggerDownload({
      data,
      fileName: `AFS-MarginProcessing-Export_${DateTime.now().toFormat(
        "yyyyMMdd"
      )}`,
    });
    return data;
  };

  return useQuery([queryKeys.getMarginCalls], fetchMarginCalls, {
    enabled: false,
    onSuccess: () => {},
    onError: (error: AxiosError<{ errorDescription: string }>) => {
      const status = error.response?.status || error.request.status;
      if (status === 400) {
        toast({
          title: "The request failed",
          status: "error",
          duration: null,
          isClosable: true,
          description: error.response?.data.errorDescription,
        });
      }
      if (status === 403) {
        toast({
          title: "Unauthorized",
          status: "error",
          duration: null,
          isClosable: true,
          description:
            "Sorry, the request cannot be completed. Additional permissions are required.",
        });
      }
      if (status === 500) {
        setAlert({
          variant: "error",
          description:
            "Sorry, this service is temporarily unavailable. The request failed.",
          title: "System Unavailable",
          isClosable: true,
        });
      }
    },
  });
}

type TriggerDownloadProps = {
  data: any;
  fileName: string;
};

function triggerDownload({ data, fileName }: TriggerDownloadProps) {
  const blob = new Blob([data]);
  const blobUrl = window.URL.createObjectURL(new Blob([blob]));

  const link = document.createElement("a");
  document.body.appendChild(link);
  link.href = blobUrl;
  link.setAttribute("download", `${fileName}.csv`);
  link.click();
  document.body.removeChild(link);
  return blobUrl;
}
